/*
// -*- coding: utf-8 -*-
// (c) 2018 Andreas Motl <andreas.motl@ip-tools.org>
*/

/* Material Components for the web */
require('./material.css');

/* Generic CSS styles */
require('./generic.css');

/* Application-specific CSS styles */
require('./app.css');
